import { render, staticRenderFns } from "./OrdersGroup.vue?vue&type=template&id=471d33b0&scoped=true"
import script from "./OrdersGroup.vue?vue&type=script&lang=js"
export * from "./OrdersGroup.vue?vue&type=script&lang=js"
import style0 from "./OrdersGroup.vue?vue&type=style&index=0&id=471d33b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471d33b0",
  null
  
)

export default component.exports